
import bugsnag from '@bugsnag/js';

// HeadlessChrome を含む自動操作ブラウザを判定する。
// UA と Client Hints はどちらか一方だけが正体を漏らす関係にあるため両方見る。
// 観測された bot は UA を通常の Chrome に偽装しつつ Client Hints に HeadlessChrome を残し、
// 現行の Chrome headless は逆に Client Hints では Google Chrome を名乗り UA にだけ残す
// ref: https://github.com/radicodeinc/value_press/issues/18406
function isAutomatedBrowser() {
  if (navigator.webdriver === true) return true;
  if (/headless/i.test(navigator.userAgent)) return true;

  var brands = (navigator.userAgentData && navigator.userAgentData.brands) || [];
  for (var i = 0; i < brands.length; i++) {
    if (brands[i] && /headless/i.test(brands[i].brand)) return true;
  }
  return false;
}

// X の iOS アプリ内ブラウザ (WKWebView) が注入したスクリプト自身のエラーは修正できないため通知しない。
// メッセージ・UA・行番号は自社コードと衝突するため、判定はスタックフレームだけで行う。
// 関数名が自社に存在しない前提は spec/etc/bugsnag_injected_script_methods_spec.rb で担保している。
// ref: https://github.com/radicodeinc/value_press/issues/18227
var INJECTED_SCRIPT_METHODS = ['updateGapFiller', 'updateFooterPositions'];

function isInjectedUserScriptError(event) {
  var stacktrace = (event.errors[0] && event.errors[0].stacktrace) || [];

  for (var i = 0; i < stacktrace.length; i++) {
    var frame = stacktrace[i] || {};
    // 注入スクリプトと断定できるフレーム
    if (typeof frame.file === 'string' && frame.file.indexOf('user-script:') === 0) return true;
    // WebKit によってはドキュメント URL に帰属するため関数名でも判定する
    if (INJECTED_SCRIPT_METHODS.indexOf(frame.method) !== -1) return true;
  }
  return false;
}

window.webpackBugsnagClient = bugsnag.start({
  apiKey: 'e8e3d2b68c784a531c5c08abff8062e6',
  releaseStage: 'production',
  enabledReleaseStages: ['production'],
  // エラーレポートをカスタマイズ
  // ref: https://docs.bugsnag.com/platforms/javascript/customizing-error-reports/
  onError: function (event) {
    // bot 由来のエラーは実ユーザーに影響しないため通知しない
    if (isAutomatedBrowser()) return false;
    // アプリ内ブラウザが注入したスクリプト由来のエラーは通知しない
    if (isInjectedUserScriptError(event)) return false;
    // HTTPステータスコード499はユーザーに影響ないため例外飛ばさない
    // ref: https://github.com/radicodeinc/value_press/issues/10125#issuecomment-810073279
    if (event.errors[0].errorMessage === "Request failed with status code 499") return false;
    if ($(".current_login").val() === "true") {
      event.addMetadata("user", {
        id: $(".current_id").val(),
        name: $(".current_name").val(),
        email: $(".current_email").val()
      });
    }
  }
});

